<template>
  <div class="submitOrderContainer">
    <div class="submitOrder w">
      <div class="title">
        <img src="./images/win.png" alt="" />
        订单提交成功!
      </div>
      <p>感谢您的信任，您的订单正在紧张审核中，我们会尽快为您审核发出。</p>
      <div class="order">
        <ul>
          <li>
            订单号：
            <span class="red">{{ info.Number }}</span>
          </li>
          <li>
            下单时间:
            <span>{{ info.billdate }}</span>
          </li>
          <li>
            订单金额:
            <span
              >￥{{
                parseFloat(
                  parseFloat(info.Total) + parseFloat(info.kdf) + taxes
                ).toFixed(2)
              }}</span
            >
          </li>
        </ul>
      </div>

      <div class="btns">
        <div class="orderStaus" @click="$router.push('/order')">
          查看订单状态
        </div>
        <span></span>
        <div class="goOrder" @click="$router.push('/Product')">继续购物</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getorderbill } from "@/api";
export default {
  data() {
    return {
      info: {},
      taxes: 0,
    };
  },
  mounted() {
    this.getorderbillInfo(this.$route.query.Number);
  },
  methods: {
    async getorderbillInfo(billno) {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await getorderbill({
        usercode,
        token,
        billno,
      });
      this.info = JSON.parse(res)[0];
      if (this.info.taxtype !== "无需开票") {
        this.taxes = this.info.Total * 0.08;
      } else {
        this.taxes = 0;
      }
    },
  },
};
</script>
<style lang='less' scoped>
.submitOrderContainer {
  margin: 40px 0;
  .submitOrder {
    padding: 50px 0;
    border: 2px solid #cccccc;
    border-radius: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .title {
      display: flex;
      align-items: center;
      color: #323232;
      font-size: 16px;
      margin-bottom: 10px;
      img {
        margin-right: 10px;
      }
    }
    p {
      width: 550px;
      text-align: center;
      line-height: 35px;
      border-bottom: 1px solid #dadada;
      color: #656565;
    }
    .order {
      margin-top: 10px;
      ul {
        display: flex;
        .red {
          color: #e4020d;
        }
        li {
          padding: 0 20px;
          color: #666666;
        }
      }
    }
    .btns {
      margin-top: 30px;
      display: flex;
      span {
        margin: 0 15px;
        width: 1px;
        background: #cecece;
        height: 25px;
      }
      .orderStaus {
        width: 100px;
      }
      .goOrder {
        width: 70px;
      }
      .orderStaus,
      .goOrder {
        cursor: pointer;
        border-radius: 5px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: #fff;
        background: #e4040c;
        font-size: 14px;
      }
    }
  }
}
</style>